<div class="row">
  <div class="col-10">
    <h3 mat-dialog-title>{{ 'ChangePassword' | translate }}</h3>
  </div>
  <div class="col-2 p-0">
    <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()">
      <fa-icon [icon]="faTimesCircle"></fa-icon>
      
    </button>
  </div>
</div>


<mat-dialog-content class="change-pass-modal">
  <div class="row change-password">
    <div class="col-md-12">

      <form name="form" *ngIf="success==null|| (success!=null&&!success)" [formGroup]="form" (ngSubmit)="onSubmit()">
        <p>{{ 'Pleasedefineyournewpasswordandconfirmit' | translate }}.</p>
        <div class="form-group">
          <label for="password">{{ 'OldPassword' | translate }}</label>
          <div class="input-group change-pass-input">

            <input [type]="hide ?   'text' :'password' " placeholder="{{ 'youroldpassword' | translate }}"  class="form-control" formControlName="OldPassword"
            [ngClass]="{'is-invalid':form.get('OldPassword').touched && form.get('OldPassword').invalid}" />
            <div class="input-group-append">
              <span class="input-group-text"><mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon></span>
            </div>

            <div *ngIf="form.get('OldPassword').touched && form.get('OldPassword').invalid" class="invalid-feedback">
              <div *ngIf="form.get('OldPassword').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
              <div *ngIf="form.get('OldPassword').errors.minlength"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Incorrectpassword' | translate }}</div></div>
            </div>

          </div>


        </div>




        <div class="form-group">
          <label for="password">{{ 'NewPassword' | translate }}</label>
          <div class="input-group change-pass-input">

            <input [type]="hide1 ?   'text' :'password' " placeholder="{{ 'yournewpassword' | translate }}"  class="form-control" formControlName="NewPassword"
            [ngClass]="{'is-invalid':form.get('NewPassword').touched && form.get('NewPassword').invalid}" [pattern]="passwordPattern" />
            <div class="input-group-append">
              <span class="input-group-text"><mat-icon matSuffix (click)="hide1 = !hide1">{{hide1 ? 'visibility' : 'visibility_off'}}</mat-icon></span>
            </div>

            <div *ngIf="form.get('NewPassword').touched && form.get('NewPassword').invalid" class="invalid-feedback">
              <div *ngIf="form.get('NewPassword').errors.required"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}</div></div>
              <!-- <div *ngIf="form.get('NewPassword').errors.minlength"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RegisterPasswordValidationConstraint' | translate }}</div></div> -->
              <div *ngIf="form.get('NewPassword').errors.pattern"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RegisterPasswordValidationConstraint' | translate }}</div></div>
            </div>

          </div>

        </div>

        <div class="form-group">
          <label for="password">{{ 'ConfirmPassword' | translate }}</label>
          <div class="input-group change-pass-input">

            <input [type]="hide2 ?   'text' :'password' "  placeholder="{{ 're-enterthenewpassword' | translate }}"  class="form-control" formControlName="ConfirmPassword"
            [errorStateMatcher]="matcher"
            [ngClass]="{'is-invalid':(form.get('ConfirmPassword').touched && form.get('ConfirmPassword').invalid )|| (submitted&&form.hasError('notSame'))}"  [pattern]="passwordPattern" />
            <div class="input-group-append">
              <span class="input-group-text"><mat-icon matSuffix (click)="hide2 = !hide2">{{hide2 ? 'visibility' : 'visibility_off'}}</mat-icon></span>
            </div>

            <div *ngIf="(form.get('ConfirmPassword').touched && form.get('ConfirmPassword').invalid ) || (submitted&&form.hasError('notSame'))"
                 class="invalid-feedback">

              <div *ngIf="form.get('ConfirmPassword').errors!=null&&form.get('ConfirmPassword').errors.required!=null">
                <div class="validation-error">
                  <fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'ThisFiledIsRequired' | translate }}
                </div>
              </div>
              <div *ngIf="submitted&&form.hasError('notSame')"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'Passwordsmustmatch' | translate }}</div></div>
              <!-- <div *ngIf="form.get('ConfirmPassword').errors!=null&&form.get('ConfirmPassword').errors.minlength"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RegisterPasswordValidationConstraint' | translate }}</div></div>
              <div *ngIf="form.get('ConfirmPassword').errors!=null&&form.get('ConfirmPassword').errors.pattern"><div class="validation-error"><fa-icon class="mr-1" [icon]="faTimesCircle"></fa-icon>{{ 'RegisterPasswordValidationConstraint' | translate }}</div></div> -->

            </div>


          </div>









        </div>



        <div class="form-group mb-0 mt-4">
          <button class="btn default-btn mr-2"  mat-button>{{ 'Confirm' | translate }}</button>
          <button (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Cancel' | translate }}</button>
        </div>
      </form>
      <!-- <h1 *ngIf="submitted&&success!=null&&success">Password Changed Successfully</h1>
      <h1 *ngIf="submitted&&success!=null&&!success">SomeThing Went wrong please try again</h1> -->

      <!-- Success -->
      <div class="mt-3" *ngIf="submitted&&success!=null&&success">
        <div class="login-form text-center sent-successfully">
          <mat-icon>check_circle_outline</mat-icon>
          <div class="text-center mb-3">
            <h1 class="text-blue mb-0">{{ 'YourPasswordChangedSuccessfully' | translate }}</h1>
          </div>
        <!--   <p class="text-center"><a class="back-to-login" (click)="showLogin()" >{{ 'BackToLogin' | translate }}</a></p> -->
        </div>
      </div>

      <!-- Not Success -->
      <div class="d-flex post-back-msg mt-3" *ngIf="submitted&&success!=null&&!success">
        <div class="d-flex justify-content-center align-items-center"><i class="fas fa-exclamation-circle mr-2 fa-2x"></i></div>
        <div class="d-flex justify-content-center align-items-center" *ngIf="errorType==onlineAccountValidation.SomethingWrongHappened">{{"Somethingwentwrongpleasetryagain" | translate}}.</div>
        <div class="d-flex justify-content-center align-items-center" *ngIf="errorType==onlineAccountValidation.EmailNotFound">{{"Somethingwentwrongpleasetryagain" | translate}}.</div>
        <div class="d-flex justify-content-center align-items-center" *ngIf="errorType==onlineAccountValidation.InvalidPassword">{{"PleaseEnterAValidPasswordAndTryAgain" | translate}}.</div>
      </div>

    </div>
  </div>
</mat-dialog-content>
